import { useState } from 'react'
import { ShareDialog } from './ShareDialog.jsx'

// Trigger button in the card foot. The full share-sheet UX (preview,
// comment, three destinations, confirmation) lives in ShareDialog.
export function ShareButton({ item, tally, userVote, isLoggedIn, onPostQuote }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <button
        type="button"
        className="share-btn"
        onClick={() => setOpen(true)}
      >
        Share
      </button>
      {open && (
        <ShareDialog
          item={item}
          tally={tally}
          userVote={userVote}
          isLoggedIn={isLoggedIn}
          onPostQuote={onPostQuote}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
